export default __webpack_public_path__ + "static/media/xx59-in-person.6d95519f.png";